export default __webpack_public_path__ + "static/media/slice-app_internship.ed0c9609.jpg";